import React from 'react'
import "./teamcard.css"
import { Col, Row } from 'react-bootstrap'

export const Teamcard = ({name, designation, description, img,note}) => {
  return (
    
    <div className='mb-5 p-4 team-card'>
        <h4 className="blue fs-2">{name}</h4>

        <h5 className='fs-4 my-3'>{designation}</h5>
        <Row>
          {
            img && <Col sm={12} lg={3} className='d-flex align-items-center justify-content-center my-3 my-lg-0'>
            <img src={img} className='image mb-4 mb-md-0' alt={`${name} – ${designation} at K-W Property Management`}></img></Col>
          }     
            <Col sm={12} lg={img?9:12}>
            <p className="lead content">{description}</p>
            <p className="lead">{note}</p>
            </Col>
        </Row>
    </div>

  )
}
